import { User, Briefcase, Building2, Shield, Award, Zap } from 'lucide-react';

// Configuration des rôles avec couleurs et icônes
export const ROLE_CONFIG = {
  beneficiaire_pro: {
    label: 'Bénéficiaire Professionnel',
    color: 'from-blue-600 to-indigo-600',
    bgLight: 'bg-blue-50',
    textColor: 'text-blue-600',
    icon: Briefcase,
    badge: 'bg-blue-100 text-blue-800'
  },
  beneficiaire_particulier: {
    label: 'Bénéficiaire Particulier',
    color: 'from-purple-600 to-pink-600',
    bgLight: 'bg-purple-50',
    textColor: 'text-purple-600',
    icon: User,
    badge: 'bg-purple-100 text-purple-800'
  },
  member: {
    label: 'Membre',
    color: 'from-blue-600 to-indigo-600',
    bgLight: 'bg-blue-50',
    textColor: 'text-blue-600',
    icon: User,
    badge: 'bg-blue-100 text-blue-800'
  },
  cooper: {
    label: 'Partenaire COOPER\'S',
    color: 'from-emerald-600 to-teal-600',
    bgLight: 'bg-emerald-50',
    textColor: 'text-emerald-600',
    icon: Building2,
    badge: 'bg-emerald-100 text-emerald-800'
  },
  expert: {
    label: 'Expert',
    color: 'from-amber-500 to-orange-600',
    bgLight: 'bg-amber-50',
    textColor: 'text-amber-600',
    icon: Award,
    badge: 'bg-amber-100 text-amber-800'
  },
  admin: {
    label: 'Administrateur',
    color: 'from-slate-700 to-slate-900',
    bgLight: 'bg-slate-50',
    textColor: 'text-slate-600',
    icon: Shield,
    badge: 'bg-slate-100 text-slate-800'
  },
  super_admin: {
    label: 'Super Administrateur',
    color: 'from-rose-600 to-red-600',
    bgLight: 'bg-rose-50',
    textColor: 'text-rose-600',
    icon: Zap,
    badge: 'bg-rose-100 text-rose-800'
  }
};
